import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  Message,
  InputNumber,
  IconButton,
  Icon,
} from 'rsuite'
import { isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import TagetDep6Table from './TagetDep6Table'
import scrollToComponent from 'react-scroll-to-component'
import NumberFormat from 'react-number-format'

export default function TagetDep6Form({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  ...props
}) {
  const { isDeleteError, isError, loading } = props

  const [schema, setSchema] = useState(_schema)
  const [isAdd, setIsAdd] = useState(false)
  const [editId, setEditId] = useState()
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)
  const [section, setSection] = useState()

  const [targetName, setTargetName] = useState()
  const [targetTotal, setTargetTotal] = useState()
  const [targetUnit, setTargetUnit] = useState()
  const [targetDetail, setTargetDetail] = useState()

  const selectedIdName = 'selectedId'

  useEffect(() => {
    setSchema(_schema)
    setIsAdd(isError)
    setIsDeleteFail(isDeleteError)
  }, [_schema])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  const onAdd = () => {
    setValue(selectedIdName, -1)

    setTargetName('')
    setTargetTotal('')
    setTargetUnit('')
    setTargetDetail('')
    setEditId('')
    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)

    setValue(selectedIdName, '')

    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const handleEdit = (data) => {
    setValue(selectedIdName, data.id)
    setValue(schema.targetValue.name, data.targetName)
    setValue(schema.targetTotal.name, data.targetTotal)
    setValue(schema.targetUnit.name, data.targetUnit)

    schema.targetDetail && setValue(schema.targetDetail.name, data.targetDetail)

    setTargetName(data.targetName)
    setTargetTotal(data.targetTotal)
    setTargetUnit(data.targetUnit)
    setTargetDetail(data.targetDetail)
    setEditId(data.id)

    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  return (
    <>
      <Panel
        bordered
        header={schema.targetValue.label}
        style={{ marginBottom: 5 }}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {schema.taget.message && (
          <>
            {schema.taget.message.map((item) => {
              return (
                <Row style={{ marginBottom: 10 }}>
                  <Message showIcon type={item.type} description={item.description} />
                </Row>
              )
            })}
          </>
        )}

        {isAdd && (
          <Form fluid>
            <Controller
              key={selectedIdName}
              name={selectedIdName}
              control={control}
              defaultValue={editId}
            />

            <Row style={{ marginBottom: 10 }}>
              <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.targetValue.name]} />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.targetTotal.name]} />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.targetUnit.name]} />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={12} lg={12}>
                <ControlLabel>
                  {requiredFiled(schema.targetValue.validators, schema.targetValue.label)}
                </ControlLabel>
                <Input
                  name={schema.targetValue.name}
                  disabled={schema.targetValue.disabled}
                  defaultValue={targetName}
                  placeholder={schema.targetValue.hint}
                  inputRef={register(isValidators(schema.targetValue.validators))}
                  onChange={(value) => {
                    setTargetName(value)
                  }}
                />
              </Col>

              <Col xs={24} sm={24} md={6} lg={6}>
                <ControlLabel>
                  {requiredFiled(schema.targetTotal.validators, schema.targetTotal.label)}
                </ControlLabel>
                <Controller
                  key={schema.targetTotal.name}
                  name={schema.targetTotal.name}
                  control={control}
                  rules={isValidators(schema.targetTotal.validators)}
                  defaultValue={targetTotal}
                  render={(props) => {
                    return (
                      // <InputNumber
                      //   min={0}
                      //   disabled={schema.targetTotal.disabled}
                      //   value={props.value}
                      //   placeholder={schema.targetTotal.hint}
                      //   onChange={(value) => {
                      //     props.onChange(value)
                      //     setTargetTotal(value)
                      //   }}
                      // />
                      <NumberFormat
                        className="rs-input"
                        disabled={schema.targetTotal.disabled}
                        placeholder={schema.targetTotal.hint}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                          setTargetTotal(value.floatValue)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6}>
                <ControlLabel>
                  {requiredFiled(schema.targetUnit.validators, schema.targetUnit.label)}
                </ControlLabel>
                <Input
                  name={schema.targetUnit.name}
                  disabled={schema.targetUnit.disabled}
                  defaultValue={targetUnit}
                  placeholder={schema.targetUnit.hint}
                  inputRef={register(isValidators(schema.targetUnit.validators))}
                  onChange={(value) => {
                    setTargetUnit(value)
                  }}
                />
              </Col>
            </Row>

            {schema.targetDetail && (
              <Row style={{ marginTop: 10 }}>
                <Col>
                  <ErrorMessage error={errors[schema.targetDetail.name]} />
                </Col>
                <Col>
                  <ControlLabel>
                    {requiredFiled(schema.targetDetail.validators, schema.targetDetail.label)}
                  </ControlLabel>
                  <Input
                    rows="3"
                    componentClass="textarea"
                    name={schema.targetDetail.name}
                    disabled={schema.targetDetail.disabled}
                    defaultValue={targetDetail}
                    placeholder={schema.targetDetail.hint}
                    inputRef={register(isValidators(schema.targetDetail.validators))}
                    onChange={(value) => {
                      setTargetUnit(value)
                    }}
                  />
                </Col>
              </Row>
            )}

            {isSaveError && (
              <Row style={{ marginTop: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={`บันทึก ${schema.buttonText ? schema.buttonText : ''} ไม่สำเร็จ`}
                />
              </Row>
            )}

            <Row style={{ marginTop: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                <div>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon className="bt-gost-icon-radius" icon="save" />}
                    onClick={onSubmit}
                    style={{ marginRight: 5 }}
                    disabled={loading}
                  >
                    {`บันทึก${schema.buttonText || ''}`}
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
                    onClick={(e) => {
                      setIsAdd(false)
                      setIsSaveError(false)
                      scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                    }}
                    style={{ marginRight: 5 }}
                    disabled={loading}
                  >
                    {`ยกเลิก${schema.buttonText || ''}`}
                  </IconButton>
                </div>
              </Col>
            </Row>
          </Form>
        )}

        {!isAdd && !schema.addButtonDisabled && (
          <Row style={{ marginTop: 10 }}>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
              <div>
                <IconButton
                  appearance="ghost"
                  icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                  onClick={onAdd}
                  style={{ marginRight: 5 }}
                >
                  {`เพิ่ม${schema.buttonText || ''}`}
                </IconButton>
              </div>
            </Col>
          </Row>
        )}

        {isDeleteFail && (
          <Row style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={`ลบ${schema.buttonText ? schema.buttonText : ''}ไม่สำเร็จ`}
            />
          </Row>
        )}
        <Row style={{ marginTop: 10 }}>
          <TagetDep6Table
            schema={schema}
            isEdit={true}
            handleDelete={onDelete}
            handleEdit={handleEdit}
          />
        </Row>
      </Panel>
    </>
  )
}
